<template>
    <v-container class="error-message-container py-15 d-flex justify-center align-center flex-column">
        <img class="icon-error-url" src="@/assets/img/error-url.svg" />
        <div class="error-message-content py-5 px-5">
            <h2 class="title">That URL address doesn’t look right.</h2>
            <p class="description">Please check that the URL is correct & try again or return to the previous page.</p>
        </div>
    </v-container>
</template>

<script>
export default {
    name: 'ErrorPage',
    props: {},
    data() {
        return {};
    },
    methods: {}
};
</script>

<style lang="scss" scoped>
.error-message-container {
    text-align: center;
    height: 100%;
}

.icon-error-url {
    height: 250px;
}

.error-message-content {
    .title {
        font-size: 26px;
        font-weight: bold;
    }

    .description {
        font-size: 16px;
        margin-top: 16px;
    }
}
</style>
